import { memo } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import ClearIcon from '@mui/icons-material/Clear';
import PropTypes from 'prop-types';
//Local files
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import { checkValidEmail } from 'helpers';

const Emails = ({ emails, setEmails, title, edit }) => {

  const handleAddEmail = () => {
    setEmails([...emails, '']);
  };
  const handleRemoveEmail = (index) => {
    setEmails(emails.filter((_, i) => i !== index));
  };
  const handleEmailChange = (index, email) => {
    const updatedEmails = [...emails];
    updatedEmails[index] = email;
    setEmails(updatedEmails);
  };

  return ( 
    <Box width='100%' mt={1}>
      <Box display='flex' alignItems='center' justifyContent='space-between'>
        <Typography sx={{ fontSize: '1.3rem', fontWeight: 400 }}>{title}</Typography>
        {edit && <Button onClick={handleAddEmail} variant="contained" color="primary">
          + Add email
        </Button>}
      </Box>
      {emails.length > 0 && emails.map((e, index) => (
        <Box key={index} display="flex" alignItems="center" width='100%' mt={2}>
          <TextField
            fullWidth
            value={e}
            onChange={(e) => handleEmailChange(index, e.target.value)}
            placeholder="Enter email"
            error={!checkValidEmail(e)}
            helperText={!checkValidEmail(e) && 'Email is invalid'}
          />
          {edit && <IconButton onClick={() => handleRemoveEmail(index)}>
            <ClearIcon />
          </IconButton>}
        </Box>
      ))}
    </Box>       
  );
};

Emails.propTypes = {
  emails: PropTypes.array.isRequired, 
  setEmails: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  edit: PropTypes.bool.isRequired
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <Emails {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);